














import {Component, Prop, Vue} from "vue-property-decorator";
import _ from 'lodash'
import DialogFooter from "@/component/Dialog/dialog-footer.vue";

abstract class BaseBtncfg {
  text!: string
  show!: boolean
  type!: string
}

export class CancelBtncfg extends BaseBtncfg {
}

export class ConfirmBtncfg extends BaseBtncfg {
}

@Component({
  components: {
    DialogFooter,
  }
})
export default class BaseDialog extends Vue {
  @Prop() protected title!: string | undefined
  @Prop() protected confirm!: (() => void) | undefined

  @Prop()
  protected cancelBtncfg!: CancelBtncfg | undefined

  @Prop()
  protected confirmBtncfg!: ConfirmBtncfg | undefined

  @Prop() protected beforeOpen!: (() => void) | undefined
  @Prop() protected afterOpen!: (() => void) | undefined

  @Prop() protected before!: (() => void) | undefined
  @Prop() protected after!: (() => void) | undefined

  @Prop() protected beforeClose!: (() => void) | undefined
  @Prop() protected afterClose!: (() => void) | undefined

  protected visible = false

  get isOpened() {
    return this.visible
  }

  get isClosed() {
    return this.visible
  }

  async open() {
    if (this.beforeOpen != undefined)
      await this.beforeOpen()
    this.visible = true
    if (this.afterOpen != undefined)
      await this.afterOpen()
  }

  async close() {
    if (this.beforeClose != undefined)
      await this.beforeClose()

    this.visible = false
    if (this.afterClose != undefined)
      await this.afterClose()
  }

  protected defaultCancelBtncfg: CancelBtncfg = {
    type: '',
    text: this.$translate('cancel'),
    show: true,
  }

  protected get _cancelBtncfg() {
    return _.merge({}, this.defaultCancelBtncfg, this.cancelBtncfg)
  }

  protected defaultConfirmBtncfg: ConfirmBtncfg = {
    text: this.$translate('confirm'),
    type: 'primary',
    show: true,
  }

  protected get _confirmBtncfg() {
    return _.merge({}, this.defaultConfirmBtncfg, this.confirmBtncfg)
  }

  protected async doConfirm() {
    if (this.before != undefined)
      await this.before()
    if (this.confirm != undefined)
      await this.confirm()
    if (this.after != undefined)
      await this.after()
    this.close()
  }
}
